import React from "react";
import BaseBage from "../BasePage";

export default function WeatherMonitoring() {
  return (
    <>

      <BaseBage
        dataKey="WeatherMonitoring"
        imageEndpoint={null}
        statsEndpoint={null}
        route="Weather-Monitoring"
      />
      <a href="https://open-meteo.com/" className="weather-attr">Weather data by Open-Meteo.com</a>
    </>
  );
}
